export const PlatformPerformanceStore = (initialData: Array<PlatformPerformanceEvent> = []) => {
	const eventData: Array<PlatformPerformanceEvent> = initialData
	const addPlatformPerformanceEvent = (name: string, startTime: number = Date.now()) => {
		eventData.push({ name: `${name} (server)`, startTime })
	}
	const getAllPlatformPerformanceEvents = () => eventData

	return { addPlatformPerformanceEvent, getAllPlatformPerformanceEvents }
}

export type PlatformPerformanceStoreType = {
	getAllPlatformPerformanceEvents: () => Array<PlatformPerformanceEvent>
	addPlatformPerformanceEvent: (name: string, startTime?: number) => void
}

export type PlatformPerformanceEvent = {
	name: string
	startTime: number
}
